import type { EmployeeAlertInvalidLegalFullName } from '@/common/graphql';

export const DetailDescriptionEmployeeAlertInvalidLegalFullName = ({
  reason,
}: {
  reason: Pick<EmployeeAlertInvalidLegalFullName, 'legalFullName' | 'detailMessage'>;
}) => (
  <>
    <div>
      Legal full name:&nbsp;
      {reason.legalFullName}
    </div>
    <div>
      Reason:&nbsp;
      {reason.detailMessage}
    </div>
  </>
);
